module.exports = __webpack_public_path__ + "static/media/slide-5mr.729a94dd.jpg";